
import React, {ReactElement} from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import {Col, Container, Row} from "react-bootstrap";
import "./c66_multi_layout_text.scss";
import {columnLayout, extraSmallLayout} from "../../utils/device";
import {insertHtml} from "../../utils/dom";


interface C66MultiLayoutTextData {
    title?: string;
    content: string;
}

/**
 * The component 66 renders some editor defined HTML ("content") with an optional black title.
 *
 * Its layout changes according to the template page layout:
 *  - on a single column layout the component shows the title in a left column and the content on the right one
 *  - on a two columns page layout, both the title and the content are shown one below the other in the right column
 *
 */
class C66MultiLayoutText extends TemplateComponent<C66MultiLayoutTextData, TemplateComponentProps<C66MultiLayoutTextData>> {


    componentRender(data: C66MultiLayoutTextData): ReactElement<any> {


        let titleElement: ReactElement | undefined;
        if (data.title) {
            titleElement = <h3 className="title">{data.title}</h3>;
        }

        let contentElement = <div className="content editor-html editor-html-right-col" {...insertHtml(data.content)} />;

        // If we have only one column and we are not on mobile,
        // we return a two column container with the title centered on the left and the content on the right
        if (this.props.layoutColumns === 1 && !extraSmallLayout()) {
            return (
                <Container className="c66-multi-layout-text" fluid={true}>
                    <Row>
                        <Col {...columnLayout(4)}>
                            {titleElement}
                        </Col>
                        <Col {...columnLayout(8)}>
                            {contentElement}
                        </Col>
                    </Row>
                </Container>
            );
        }

        // If the page has a 2 columns-layout, we return the content below the title, both on the right column
        return (
            <div className="c66-multi-layout-text">
                {titleElement}
                {contentElement}
            </div>
        );
    }
}

export default C66MultiLayoutText;